import { mapGetters } from 'vuex'
import fetchable from '@mixins/fetchable'

export default {
  mixins: [ fetchable ],
  computed: {
    ...mapGetters(['memberTransactionDetailsLoading', 'memberDetails']),
    restoredFromTransaction () {
      return this.$route.query && this.$route.query.transactionId
    },
    fetchers () {
      return [
        {
          action: 'GET_MEMBER_TRANSACTION_DETAILS',
          shouldFetch: this.restoredFromTransaction,
          options: {
            transactionId: this.$route.query.transactionId
          }
        }
      ]
    }
  },
  watch: {
    'memberTransactionDetailsLoading' (isLoading, wasLoading) {
      if (!isLoading && this.restoredFromTransaction) {
        if (this.$route.name === 'primary-subscriber-details') {
          this.transformMemberDetailsForPrimarySubscriberDetails()
        } else if (this.$route.name === 'add-dependent') {
          this.transformMemberDetailsForAddDependent()
        }
      }
    }
  },
  methods: {
    transformMemberDetailsForPrimarySubscriberDetails () {
      // This pipes values into state so that Add Family can use them...
      this.$store.dispatch('addFamily/LOAD_ADD_SUBSCRIBER_TRANSACTION', this.memberDetails)
    },
    transformMemberDetailsForAddDependent () {
      let memberDetails = this.memberDetails

      this.eyemedMemberId = memberDetails.eyemedMemberId
      this.fileBoundId = memberDetails.fileBoundId
      this.clientId = memberDetails.clientHealthId
      this.firstName = memberDetails.memberFirstName
      this.middleInitial = memberDetails.memberMidInitial
      this.lastName = memberDetails.memberLastName
      this.suffix = memberDetails.memberNameSuffix
      this.dob = memberDetails.memberDateOfBirth
      this.gender = memberDetails.gender
      this.ssn = memberDetails.ssn
      this.relationship = memberDetails.relationship

      let contactInfo = memberDetails.primaryAddress
      contactInfo.phone = memberDetails.phone
      contactInfo.email = memberDetails.email
      this.contactInformation = contactInfo

      this.reportingCodes = {
        divisionCode: memberDetails.reportingCodes.divisionCode,
        benefitOption: memberDetails.reportingCodes.benefitOption,
        locationCode: memberDetails.reportingCodes.locationGroupNumber || memberDetails.reportingCodes.locationCode,
        companyCode: memberDetails.reportingCodes.companyCode,
        clientGroupNumber: memberDetails.reportingCodes.clientGroupNumber,
        reportingCode1: memberDetails.reportingCodes.reportingCodes[0],
        reportingCode2: memberDetails.reportingCodes.reportingCodes[1],
        reportingCode3: memberDetails.reportingCodes.reportingCodes[2],
        reportingCode4: memberDetails.reportingCodes.reportingCodes[3],
        reportingCode5: memberDetails.reportingCodes.reportingCodes[4]
      }

      this.privacyAddress = {
        firstName: memberDetails.privacy.firstName,
        lastName: memberDetails.privacy.lastName,
        midInitial: memberDetails.privacy.midInitial,
        suffix: memberDetails.privacy.suffix, // todo this is not coming back
        line1: memberDetails.privacy.address.line1,
        line2: memberDetails.privacy.address.line2,
        line3: memberDetails.privacy.address.line3,
        zipCode: memberDetails.privacy.address.zip,
        city: memberDetails.privacy.address.city,
        state: memberDetails.privacy.address.state,
        county: memberDetails.privacy.address.county,
        foreignIndicator: memberDetails.privacy.address.foreignIndicator
      }

      this.languageAssistance = {
        writtenLanguage: memberDetails.writtenLanguage ? memberDetails.writtenLanguage.code : '',
        spokenLanguage: memberDetails.spokenLanguage ? memberDetails.spokenLanguage.code : '',
        race: memberDetails.race ? memberDetails.race.code : '',
        ethnicity: memberDetails.ethnicity ? memberDetails.ethnicity.code : ''
      }

      this.groupCk = memberDetails.coverage.groupCk
      this.subGroupCk = memberDetails.coverage.subGroupCk
      this.classId = memberDetails.coverage.classId
      this.planId = memberDetails.coverage.planId
      this.effectiveDate = memberDetails.coverage.startDate
      this.termDate = memberDetails.coverage.endDate
      this.subscriberCk = memberDetails.subscriberCk
      this.memberCk = memberDetails.memberCk
    }
  }
}
